import { render, staticRenderFns } from "./ButtonLight.vue?vue&type=template&id=3d11b249&scoped=true&"
import script from "./ButtonLight.vue?vue&type=script&lang=js&"
export * from "./ButtonLight.vue?vue&type=script&lang=js&"
import style0 from "./ButtonLight.vue?vue&type=style&index=0&id=3d11b249&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d11b249",
  null
  
)

export default component.exports